import { readable, derived } from 'svelte/store';

import { loadTrackerData, loadTrackerData2 } from '../utils/load';

import {
  statusFilter,
  countryFilter,
  useCaseFilter,
  technologyFilter,
  architectureFilter,
  //infrastructureFilter,
  //accessFilter,
  //corporatePartnershipFilter,
  //crossborderPartnershipsFilter
} from './filter';
import { areAllSelected, hasOverlap } from '../utils/logic';
import {
  categoryNameScale,
  statusColorScale,
  countryColorScale,
  useCaseColorScale,
  technologyColorScale,
  architectureColorScale,
  //infrastructureColorScale,
  //accessColorScale
} from '../stores/scales';
import styles from '../utils/styles';

// static test filter data & spotlight & new data
// const trackerDataPath = 'data/tracker-test-spotlight-new-data.csv';

// live data v2: add 'Overview Spotlight' + 'Key Developments Spotlight'
const trackerDataPath = 'https://docs.google.com/spreadsheets/d/e/2PACX-1vQh27kpYjCRmNoWa4FEpWqLSxLLaqK_hlgqP6wGQLp8Pum7guAYS6i0qt6wIRAPvb5Up6-6wvmTN05s/pub?gid=0&single=true&output=csv';

// live data v1
// const trackerDataPath = 'https://docs.google.com/spreadsheets/d/e/2PACX-1vRvC1JtWY8a2W4b8DLPfnfb9rmhuHBmWO22TvSXXpk25CZTBU9_8f6YtxM9rmBK2YajII5ltDE6ynGZ/pub?gid=0&single=true&output=csv';

// ignore
// const trackerDataPath = 'https://docs.google.com/spreadsheets/d/e/2PACX-1vSgtFtB8hLrJ0VcWV9pASEAprK4foQsOHai9gWBNNzm4ZwATV35-gaoLm_7Q0FgGw1mXJ4sOhMDX5HW/pub?gid=0&single=true&output=csv'

export const rawData = readable([], async (set) => {
  //set(await loadTrackerData(trackerDataPath));
  set(await loadTrackerData2());
});

/*export const rawData2 = readable([], async (set) => {
  set(await loadTrackerData2());
});*/

export const scaledData = derived(
  [
    rawData,
    categoryNameScale,
    statusColorScale,
    countryColorScale,
    useCaseColorScale,
    technologyColorScale,
    architectureColorScale,
    //infrastructureColorScale,
    //accessColorScale,
  ],
  ([
    $rawData,
    $categoryNameScale,
    $statusColorScale,
    $countryColorScale,
    $useCaseColorScale,
    $technologyColorScale,
    $architectureColorScale,
    //$infrastructureColorScale,
    //$accessColorScale,
  ]) => {
    return $rawData.map((d) => {
      return {
        ...d,
        name: {
          name: d.name,
          title: $categoryNameScale.name,
          color: $countryColorScale[d.name],
          filterable: true
        },
        categories: {
          ...d.categories,
          new_status: {
            name: d.categories.new_status,
            title: $categoryNameScale.new_status,
            color: $statusColorScale[d.categories.new_status],
            filterable: true
          },
          use_case: {
            name: d.categories.use_case,
            title: $categoryNameScale.use_case,
            color: 'transparent',//$useCaseColorScale[d.categories.use_case],
            filterable: true
          },
          technology: {
            name: d.categories.technology,
            title: $categoryNameScale.technology,
            color: $technologyColorScale[d.categories.technology],
            filterable: false
          },
          architecture: {
            name: d.categories.architecture,
            title: $categoryNameScale.architecture,
            color: 'transparent',//$architectureColorScale[d.categories.architecture],
            filterable: true
          },
          infrastructure: {
            name: d.categories.infrastructure,
            title: $categoryNameScale.infrastructure,
            color: styles.gray,//$infrastructureColorScale[d.categories.infrastructure],
            filterable: false
          },
          access: {
            name: d.categories.access,
            title: $categoryNameScale.access,
            color: styles.gray,//$accessColorScale[d.categories.access],
            filterable: false
          },
          corporate_partnership: {
            name: d.categories.corporate_partnership,
            title: $categoryNameScale.corporate_partnership,
            color: styles.gray,
            filterable: false
          },
          crossborder_partnerships: {
            name: d.categories.crossborder_partnerships,
            title: $categoryNameScale.crossborder_partnerships,
            color: styles.gray,
            filterable: false
          }
        }
      };
    });
  }, []);

export const data = derived(
  [
    scaledData,
    statusFilter,
    countryFilter,
    useCaseFilter,
    technologyFilter,
    architectureFilter,
    //infrastructureFilter,
    //accessFilter,
    //corporatePartnershipFilter,
    //crossborderPartnershipsFilter,
  ],
  ([
    $scaledData,
    $statusFilter,
    $countryFilter,
    $useCaseFilter,
    $technologyFilter,
    $architectureFilter,
    //$infrastructureFilter,
    //$accessFilter,
    //$corporatePartnershipFilter,
    //$crossborderPartnershipsFilter,
  ]) => {
    return $scaledData.map((d) => {
      return {
        ...d,
        show:
          hasOverlap([d.categories.new_status.name], $statusFilter) &&
          hasOverlap([d.name.name], $countryFilter) &&
          (hasOverlap([d.categories.use_case.name], $useCaseFilter, true) || areAllSelected($useCaseFilter)) &&
          hasOverlap([d.categories.technology.name], $technologyFilter) &&
          hasOverlap([d.categories.architecture.name], $architectureFilter) /*&&
          hasOverlap([d.categories.infrastructure.name], $infrastructureFilter) &&
          hasOverlap([d.categories.access.name], $accessFilter) &&
          hasOverlap(
            [d.categories.corporate_partnership.name],
            $corporatePartnershipFilter
          ) &&
          hasOverlap(
            [d.categories.crossborder_partnerships.name],
            $crossborderPartnershipsFilter
          ),*/
      };
    });
  },
  []
);




/*
Array

Object
  categories: Object
    access: "Account"
    architecture: "Hybrid"
    corporate_partnership: "Undecided"
    crossborder_partnerships: "mCBDC Bridge"
    infrastructure: "Both"
    new_status: "Pilot"
    technology: "Undecided"
    use_case: "Both"
    Object prototype
  currency_name: "e-CNY"
  key_developments: "In 2017, as a part of a wider push to develop its high-technology sectors, China launched a project called Digital Currency Electroni…"
  key_developments_spotlight: ""
  name: "China"
  notes: "Overview of China is from April update of CBDC tracker"
  overview: "In April 2020, China became the world's first major economy to pilot a digital currency. As of February 2022, the pilot  has bee…"
  overview_spotlight: ""
  owner: "Nitya"
  sources: Object
    central_bank_name: "The People's Bank of China"
    central_bank_url: "http://www.pbc.gov.cn/en/3688110/3688172/4157443/4293696/2021071614584691871.pdf"
    media_urls: Array (2)
      0 "https://www.cnbc.com/2021/06/02/china-digital-currency-beijing-to-hand-out-6point2-million-in-trial.html"
      1 "https://www.coindesk.com/card-based-digital-yuan-wallet-manufacturer-to-use-fingerprint-id-tech"
      Array prototype
    Object prototype
  Object prototype

 */